const ANNUAL_DOCUMENT = "Anual";
const GRAPH_COLORS = require("./graphColors");
const INITIAL_AMOUNT = 10000;
const INITIAL_PERIOD = 3;
const DFI_DOCUMENT_TYPE = "DFI";
const SEMIANNUAL_DOCUMENT_TYPE = "InformeSemestral";
const SEARCH_FUND_CATEGORY_PAGE_NUM = "1";
const SEARCH_FUND_CATEGORY_SEARCH_LIMIT = "1";
const MORNING_STAR_RATING_TIME_PERIOD = "M255";
const PRODUCTION_ENVIRONMENT = "PRODUCCION";
const PRIIPKID_DOCUMENT = "299";
const PROSPECTUS = "Prospectus";
const BUY_AND_HOLD_WITHOUT_TAE_IN_DFI = "BH";
const BUY_AND_HOLD_WITH_TAE_IN_DFI = "BH1";
const DEFAULT_TRANSLATION_TEXT = "####";
const DEFAULT_TRANSLATION_TEXT_MISSING_VALUE = "########";
const ALTERNATIVE_INVESTMENT = "inversionAlternativa";
const MYPROFILE_BROKER_EXPLORE_URL = "/myprofile/broker/explore"
const LEGAL_DOCUMENTS_TYPES = {
    PROSPECTUS : 'Prospectus',
    INFORME_SEMESTRAL : 'informeSemestral',
    DFI: 'DFI',
    RISKS: 'risks',
    RECOMMENDATIONS: 'recommendations',
    PRESENTATION: 'presentation',
}

module.exports = {
    GRAPH_COLORS,
    INITIAL_AMOUNT,
    INITIAL_PERIOD,
    DFI_DOCUMENT_TYPE,
    SEARCH_FUND_CATEGORY_PAGE_NUM,
    SEARCH_FUND_CATEGORY_SEARCH_LIMIT,
    SEMIANNUAL_DOCUMENT_TYPE,
    MORNING_STAR_RATING_TIME_PERIOD,
    PRODUCTION_ENVIRONMENT,
    PRIIPKID_DOCUMENT,
    PROSPECTUS,
    ANNUAL_DOCUMENT,
    BUY_AND_HOLD_WITHOUT_TAE_IN_DFI,
    BUY_AND_HOLD_WITH_TAE_IN_DFI,
    DEFAULT_TRANSLATION_TEXT,
    DEFAULT_TRANSLATION_TEXT_MISSING_VALUE,
    ALTERNATIVE_INVESTMENT,
    MYPROFILE_BROKER_EXPLORE_URL,
    LEGAL_DOCUMENTS_TYPES,
};
